import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { useActiveLanguage } from 'b2b-apps/shop/i18n/hooks';
import BrandLogo from './assets/logo.svg';
import { ComponentType, Props } from './';
import './Logo.scss';

const Logo: ComponentType = ({ className }: Props): ReactElement => {
  const activeLanguage = useActiveLanguage();
  const rootClassName = classNames('Logo', className);
  return (
    <a className={rootClassName} href={`/${activeLanguage}/`}>
      <img src={BrandLogo} alt="Alltron logo" className="cds-ImgFluid" />
    </a>
  );
};

export { Logo };
